export const blockIconsMapsHandymanNew = (
	<span className='material-symbols-outlined'>handyman</span>
);
